import { getAppRouterState } from 'core/utils';
import { RouterState } from 'mobx-state-router';

const getLoginRoute = appId => {
	// return appId && appId !== '' ? getAppRouterState('master.app-login', appId) : new RouterState('master.platform.membership.login');
	return getAppRouterState('master.app.membership.login', appId);
};

export default getLoginRoute;
